<template>
  <transition name="product">
    <div class="scan-detail">
      <van-nav-bar
        @click-left="onClickLeft"
        :title="title"
        left-text="返回"
        left-arrow
      >
      </van-nav-bar>
      <div>
        <van-search
          style="margin-top: 10px"
          v-model="search_dia_value"
          show-action
          left-icon=""
          placeholder="请输入企业名称"
          @search="searchQuery"
        >
          <template #action>
            <van-button
              type="info"
              @click="searchQuery"
              style="height: 34px; padding: 0 10px"
            >
              <div style="display: flex; align-items: center">
                <van-icon name="search" style="margin-right: 2px" />信息检索
              </div>
            </van-button>
          </template>
        </van-search>
        <div class="item mcols comWrapper card mt-2 mb-2 p-3">
          <van-cell
            v-for="(item, index) in e10_1_list"
            @click="viewDetail(item)"
            :key="index"
          >
            <template #title>
              {{ item.companyName }}
            </template>
            <template #extra>
              <div class="van-cell__value">
                查看详情
                <van-icon name="arrow" />
              </div>
            </template>
          </van-cell>
          <van-cell v-if="e10_1_list.length==0">
            <template #title>
              暂无企业信息
            </template>
          </van-cell>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      search_dia_value: "",
      title: "",
      e10_1_list: [],
    };
  },
  methods: {
    searchQuery() {
      this.getData();
    },
    onClickLeft() {
      this.$router.back();
    },
    viewDetail(item) {
      this.$router.push({
        name: "e10_detial_2",
        query: item,
      });
    },
    getData() {
      let query = this.$route.query;
      this.title = query.year + "年投产企业";
      this.request({
        url: "/v1.0/company/getCompanyByIds",
        method: "GET",
        params: { ids: query.cids,companyName: this.search_dia_value },
      })
        .then((res) => {
          if (res.success) {
            res.data.forEach((item, index) => {
              item.sort = index + 1;
              item.pids = query.pids;
              item.e10_1_year = query.year;
            });

            this.e10_1_list = res.data;
          }
        })
        .catch((err) => {});
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";

.scan-detail {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}

.item {
  margin-top: 10px;
}

.fontstyle {
  font-size: 14px;
  color: #646566;
}
.fontstyleS {
  font-size: 14px;
}

.comWrapper {
  width: 100%;
  padding: 10px;
  .comWrapper-wrapper {
    span {
      display: inline-block;
      width: 8px;
      height: 12px;
      background: #1989fa;
    }
  }
}

.van-cell__value {
  flex: 4;
  text-align: left;

  &.center {
    text-align: center;
  }
}

.van-cell {
  padding: 10px 12px;
}

.mycs.badge-warning {
  color: #33333393 !important;
  background-color: #ffc10766 !important;
}
.badge {
  font-weight: 600;
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.coll2 .van-cell {
  padding: 10px 0;
}
.coll2 .van-cell__value {
  flex: 1.8;
  margin-left: 8px;
}
.mcols .van-cell__value {
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: none;
}
</style>